import { transactions } from '../endpoints';
import { Api } from '../api';
import type { ApiPaginate, ApiResponse, FileResponse } from '../../models';
import type { CreateTransactionReceiptRequest, TransactionRequest, TransactionResponse, UpdateTransactionRequest } from './models';

export class TransactionsApi extends Api {
  static getTransactions = (request?: TransactionRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<TransactionResponse[]>>({ url: transactions.getTransactions(), queryParams: request, signal });

  static updateTransaction = (request: UpdateTransactionRequest) =>
    this.put<UpdateTransactionRequest, ApiResponse<TransactionResponse>>({ url: transactions.updateTransaction(), data: request });

  static createReceiptTransaction = ({ refNum, receipt }: CreateTransactionReceiptRequest) =>
    this.post<FormData, ApiResponse<TransactionResponse>>({ url: transactions.createReceipt(refNum), data: receipt });

  static getReceipt = (id: string, signal?: AbortSignal) => this.get<FileResponse>({ url: transactions.getReceipt(id), signal });

  static removeReceipt = (refNum: string, signal?: AbortSignal) =>
    this.delete<undefined, ApiResponse<TransactionResponse>>({ url: transactions.removeReceipt(refNum), signal });
}
